import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import DashboardPage from "./pages/DashboardPage";
import TermsPage from "./pages/TermsPage";
import PammPage from "./pages/PammPage";
import ProfitPulsePage from "./pages/Products/ProfitPulse";
import InfoLinkPage from "./pages/InfolinkPage";

const App = () => {
  return (
    <>
          <Router>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/pamm" element={<PammPage />} />
              <Route
                path="/product/profitpulse"
                element={<ProfitPulsePage />}
              />
              <Route path="/infolink" element={<InfoLinkPage />} />
              <Route path="/terms" element={<TermsPage />} />                         
              
                <Route path="/dashboard" element={<DashboardPage />} />
            </Routes>
          </Router>
    </>
  );
};

export default App;
